import { SPEEDTARGET } from "../../actions/portal";

export default function(state = [0, 0], action) {
  switch (action.type) {
    case SPEEDTARGET:
      return action.payload;
    default:
  }
  return state;
}
